<template>
  <el-container>
    <div class="sideMenu">
      <img
        src="../assets/首页/应用广场logo.png"
        class="titleIcon"
        @click="clickHome()"
      />

      <AppSquareItem
        v-for="item in headerTagList"
        :key="item.id"
        :info="item"
        :is-selected="item.id == selectedID"
        v-on:itemClick="itemClick"
      />
    </div>

    <el-main
      class="mainArea"
      :style="{
        'margin-left': this.asideWidth,
      }"
    >
      <div v-if="this.$parent.isMobile" class="rowArea">
        <span
          v-if="!isCollapse"
          class="iconfont icon-zhankai handle"
          @click="handleSide()"
        ></span>
        <span
          v-else
          class="iconfont icon-shouqi handle"
          @click="handleSide()"
        ></span>
        <div class="headRight">
          <span class="iconfont icon-sousuo souso"></span>
          <input
            type="text"
            class="searchInput"
            placeholder="请输入搜索的内容"
            @input="inputSearchValue"
            :value="searchValue"
            @keyup.enter="searchAction()"
          />
          <p class="searchBtn" @click="searchAction()">搜索</p>
        </div>
      </div>
      <div v-else class="headRight">
        <span class="iconfont icon-sousuo souso"></span>
        <input
          type="text"
          class="searchInput"
          placeholder="请输入搜索的内容"
          @input="inputSearchValue"
          :value="searchValue"
          @keyup.enter="searchAction()"
        />
        <p class="searchBtn" @click="searchAction()">搜索</p>
      </div>
      <p class="tagTitle">{{ tagTitle }}</p>
      <div class="commonTools">
        <CommonToolItem
          v-for="item in commonToolsList"
          :key="item.id"
          :info="item"
          :is-app-square="true"
          v-on:itemClick="toolItemClick(item)"
        />
      </div>
      <p class="bottomDes">
        © 2020-2023 西安二三里网络科技有限公司 版权所有 陕ICP备17017925号-1
      </p>
    </el-main>
  </el-container>
</template>
<script>
import CommonToolItem from "@/components/CommonToolItem.vue";
import {
  getHotNewsMoreList,
  getTagList,
  getAppList,
  searchAppList,
} from "../service/api";
import AppSquareItem from "@/components/AppSquareItem.vue";
export default {
  components: {
    AppSquareItem,
    CommonToolItem,
  },
  data() {
    return {
      isCollapse: false,
      tagTitle: "   ",
      searchValue: "",
      selectedID: -1,
      asideWidth: "",
      headerTagList: [],
      commonToolsList: [],
    };
  },
  computed: {},
  created() {},
  mounted() {
    let data = this.$route.query;
    if (data.tagID != "") {
      console.log("$route.query=", data);
      this.tagTitle = data.tagName;
      this.selectedID = data.tagID;
    }

    this.$parent.showTopBottomView = false;
    this.$parent.showSearch = false;
    this.getSectionHeadList();
    this.getAsideWidth();
    this.getAppListWithTag(this.tagTitle);
  },
  methods: {
    handleSide() {
      this.isCollapse = !this.isCollapse;
      if (this.isCollapse) {
        let getVwUnit = (200 / window.screen.width) * 100;
        this.asideWidth = getVwUnit + "vw";
      } else {
        this.asideWidth = 0 + "vw";
      }
    },
    clickHome() {
      this.searchValue = "";
      this.$router.push({ path: "/" });
    },
    //点击工具
    toolItemClick(item) {
      const externalLink = item.url;
      window.open(externalLink, "_blank");
    },
    //搜索
    async searchAction() {
      if (this.searchValue == "") {
        this.$message({
          message: "请输入搜索内容",
          type: "warning",
        });
        return;
      }
      const res = await searchAppList(this.searchValue);
      if (res.data.code === 200 && res.data.success) {
        this.commonToolsList = res.data.result;
        this.tagTitle = "搜索结果";
        this.selectedID = -1;
      } else {
        this.$message({
          message: res.data.message,
          type: "warning",
        });
      }
    },
    inputSearchValue(event) {
      this.searchValue = event.target.value;
    },
    itemClick(info) {
      console.log("itemClick-", info);
      this.selectedID = info.id;
      this.tagTitle = info.tagName;
      this.searchValue = "";
      if (this.selectedID == 0) {
        this.$router.push({
          path: "/",
        });
      } else {
        this.getAppListWithTag(this.tagTitle);
        this.isCollapse = false;
        this.asideWidth = 0 + "vw";
      }
    },
    getAsideWidth() {
      this.asideWidth = "0vw";
    },

    //根据分类获取应用列表
    async getAppListWithTag(tagName) {
      console.log("tagName=", tagName);
      if (tagName == undefined) {
        tagName = "";
      }
      const res = await getAppList(tagName, 20);
      if (res.data.code === 200 && res.data.success) {
        this.commonToolsList = res.data.result;
      } else {
        this.$message({
          message: res.data.message,
          type: "warning",
        });
      }
    },
    //获取顶部工具列表
    async getSectionHeadList() {
      const res = await getTagList(10);
      console.log("res=", res);
      if (res.data.code === 200 && res.data.success) {
        this.headerTagList = res.data.result;
        let newItem = {
          id: "0",
          tagImg: "icon-shouye",
          tagName: "首页",
        };
        this.headerTagList.unshift(newItem);
      } else {
        this.$message({
          message: res.data.message,
          type: "warning",
        });
      }
    },
    async getInfoListAction(name) {
      const res = await getHotNewsMoreList(name, 1, 50);
      console.log("res=", res);
      if (res.data.code === 200 && res.data.success) {
        this.dataList = res.data.result.records;
      } else {
        this.$message({
          message: res.data.message,
          type: "warning",
        });
      }
    },
    //点击资讯分类
    async clickCateTag(index) {
      this.infoCateSelectedIndex = index;
      let cate = this.infoCategoriesList[index];
      this.getInfoListAction(cate.id);
      console.log("this.infoList=", this.infoList);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 60px;
}
.el-container {
  overflow: hidden;
  height: 100%;
}
.sideMenu {
  background-color: #ffffff;
  width: 220px;
}
.el-aside {
  color: #333;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
}
.titleIcon {
  width: 106px;
  margin-top: 40px;
  margin-bottom: 28px;
  cursor: pointer;
  margin-left: 30px;
}
.el-main {
  background-color: #f3f5f7;
  position: relative;
  // padding: 0px 10%;
  // height: 100%;
}
.headRight {
  margin: 0px;
  margin-left: 12px;
  margin-top: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #ffffff;
  height: 54px;
  border-radius: 27px;
  border-style: none;
  width: 97%;
  overflow: hidden;
}
.souso {
  // position: absolute;
  margin-left: 10px;
  color: #64696f;
  font-size: 14px !important;
}
.searchInput {
  width: 85%;
  font-size: 14px;
  text-indent: 1em;
  margin-left: 50px;
  outline: none;
}
.searchInput::placeholder {
  color: #000000;
  font-size: 14px;
  margin: 0px;
}
.mainArea {
  padding: 0px 8%;
  // height: 100%;
  width: 100%;
  min-height: 930px;
  position: relative;
  overflow: hidden;
  // width: 1720px;
  // left: 200px;
}
.searchBtn {
  font-size: 17px;
  color: #000000;
  cursor: pointer;
  position: absolute;
  right: 50px;
}
.tagTitle {
  font-weight: bold;
  font-size: 18px;
  color: #000000;
  width: 100%;
  text-align: left;
  margin: 40px 0 0 12px;
}
.commonTools {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  // justify-content: space-between;
  margin-top: 30px;
  // padding: 30px;
}
.bottomDes {
  position: absolute;
  bottom: 20px;
  color: #64696f;
  font-size: 14px;
  line-height: 20px;
  // width: 100%;
  text-align: center;
  left: 50%;
  transform: translate(-50%, -50%);
}
@media screen and (max-width: 768px) {
  .el-header {
    background-color: #b3c0d1;
    color: #333;
    line-height: 60px;
  }

  .el-aside {
    color: #333;
    // display: flex;
    // flex-direction: column;
    // align-items: center;
  }
  .titleIcon {
    width: 106px;
    margin-top: 55px;
    margin-bottom: 28px;
    cursor: pointer;
    margin-left: 30px;
  }
  .el-main {
    background-color: #f3f5f7;
    position: relative;
    // padding: 0px 10%;
    // height: 100%;
  }
  .headRight {
    margin: 0px;
    margin-left: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #ffffff;
    height: 54px;
    border-radius: 27px;
    border-style: none;
    width: 97%;
    overflow: hidden;
  }
  .souso {
    // position: absolute;
    margin-left: 10px;
    color: #64696f;
    font-size: 14px !important;
  }
  .searchInput {
    width: 65%;
    height: 54px;
    font-size: 14px;
    text-indent: 1em;
    margin-left: 50px;
    outline: none;
  }
  .searchInput::placeholder {
    color: #000000;
    font-size: 14px;
  }
  .mainArea {
    padding: 0px 8%;
    // height: 100%;
    width: 100%;
    min-height: 930px;
    position: relative;
    overflow: hidden;
    flex: none;
    transition: margin-left 0.3s ease;
    // width: 1720px;
    // left: 200px;
  }
  .searchBtn {
    font-size: 17px;
    color: #000000;
    cursor: pointer;
    position: absolute;
    right: 20px;
  }
  .tagTitle {
    font-weight: bold;
    font-size: 18px;
    color: #000000;
    width: 100%;
    text-align: left;
    margin: 40px 0 0 12px;
  }
  .commonTools {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    // justify-content: space-between;
    margin-top: 30px;
    margin-bottom: 150px;
    // padding: 30px;
  }
  .bottomDes {
    position: absolute;
    bottom: 20px;
    color: #64696f;
    font-size: 14px;
    line-height: 20px;
    // width: 100%;
    text-align: center;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
  }
  .sideMenu {
    background-color: #ffffff;
    position: absolute;
    width: 200px;
    // transition: left 0.3s ease;
  }
  .rowArea {
    display: flex;
    flex-direction: row;
    margin-top: 40px;
    align-items: center;
  }
  .el-container {
    overflow: hidden;
    height: 100%;
  }
  .handle {
    font-size: 25px;
    // height: 54px;
    width: 30px;
    margin: 0px;
  }
}
</style>
